export const UserType = `{
  id
  email
  organization {
    id
    name
  }
  dateJoined
}`;

export const MailboxSessionType = `{
  id
  startedAt
  finishedAt
  totalEmails
  processedEmails
  unprocessedEmails
  reviewEmails
  failedEmails
  taskId
  status
  processingPercentage
}`;

export const MailboxType = `{
  id
  user ${UserType}
  port
  host
  password
  email
  currentSession ${MailboxSessionType}
}`;

export const DjangoFileType = `{
  name
  size
  url
}`;

export const DjangoImageType = `{
  name
  size
  url
}`;

export const EmailFileType = `{
  id
  filename
  size
  contentType
  file ${DjangoFileType}
  previewImage ${DjangoImageType}
}`;

export const ProcessedAiFileType = `{
  id
  fileType
  filename
  size
  contentType
  file ${DjangoFileType}
  applicationFile { 
      id 
    }
  sourceEmailFileIds
  bankAccountKey 
}`;

export const EmailAIExtractedOwnerType = `{
  firstName
  lastName
  fullName
  birthDate
  ssn
  mobileNumber
  emailAddress
  ownershipPercentage
  last4ssn
  address
}`;

export const EmailAiExtractedDataTableType = `{
  id
  businessName
  dba
  address
  city
  state
  zipCode
  taxId
  entityId
  createdAt
  notes
  reviewStatus
  stateUrl
  legalEntityType
  businessStartDate
  confidenceScore
  isFillApplicationForm
  isFindEntityId
  isSelectApplicationForm
  isSelectBankStatement
  isSelectAgent
  entityStatus
  otherLegalEntityType
  businessPhone
  agentId
  processedFiles ${ProcessedAiFileType}
  owners ${EmailAIExtractedOwnerType}
}`;

export const EmailAiExtractedDataType = `{
  id
  businessName
  dba
  address
  city
  state
  zipCode
  taxId
  entityId
  createdAt
  notes
  reviewStatus
  stateUrl
  legalEntityType
  businessStartDate
  confidenceScore
  isFillApplicationForm
  isFindEntityId
  isSelectApplicationForm
  isSelectBankStatement
  isSelectAgent
  entityId
  entityStatus
  otherLegalEntityType
  businessPhone
  agentId
  processedFiles ${ProcessedAiFileType}
  owners ${EmailAIExtractedOwnerType}
  email {
    id
    uid
    subject
    sender
    body
    createdAt
    files ${EmailFileType}
  }
}`;

export const EmailType = `{
  id
  mailbox ${MailboxType}
  uid
  subject
  sender
  body
  status
  session ${MailboxSessionType}
  createdAt
  files ${EmailFileType}
  submissions ${EmailAiExtractedDataType}
}`;

export const EmailProcessingStatsType = `{
  id
  totalEmails
  processedEmails
  unprocessedEmails
  reviewEmails
  failedEmails
}`;

export const NoSubmissionsEmailType = `{
  id
  mailbox ${MailboxType}
  uid
  subject
  sender
  body
  status
  session ${MailboxSessionType}
  createdAt
  files ${EmailFileType}
}`;


export const UnprocessedEmailListType = `{
  id
  mailbox { email }
  subject
  sender
  body
  createdAt
  files {
    id
    filename
    size
    file { url }
  }
}`;


export const FailedEmailListType = `{
  id
  mailbox { email }
  subject
  sender
  createdAt
  submissions { notes }
}`;

export const ApiLogsType = `{
    createdAt
    id 
    request
    response
    success
    documents  ${ProcessedAiFileType}
  }`;
